import { useState } from 'react';
import { useTranslation } from "react-i18next";

import HyperFocusBottom from '../../../HyperFocusBottom/HyperFocusBottom'
import AddUser from '../../../User/Views/AddUser'

import { FooterButtons } from './FooterButtons'
import { SwitchButton } from './SwitchButton'
import useAddUser from '../../../User/Hooks/useAddUser';
import { useGridDataQueryInvalidate } from '../../Hooks/useGridDataQueryInvalidate';

type Props = {
  showAddUserModal: boolean;
  setShowAddUserModal: (value: boolean) => void;
  setToastVisible: (value: boolean) => void;
  setToastContent: (value: string) => void;
};

export const AddUserForm = ({
  showAddUserModal,
  setShowAddUserModal,
  setToastContent,
  setToastVisible
}: Props) => {
  const { t } = useTranslation();
  const [switchChecked, setSwitchChecked] = useState(false);
  const invalidateGridDataQuery = useGridDataQueryInvalidate();

  const {
    handleSubmitButton,
    disabledButton,
    handleResetForm,
    isSendInvitationEnabled,
    isPending,
    ...rest
  } = useAddUser();

  const submitNewUser = () => {
    handleSubmitButton(
      switchChecked && isSendInvitationEnabled,
      {
        onSettled: (response) => {
          setShowAddUserModal(false);
          handleResetForm();
          if (!response?.error) {
            setToastContent(t("userManagementPage.userAdd_success"))
            setToastVisible(true)
            invalidateGridDataQuery();
          }
        }
      }
    )
  };

  return (
    <HyperFocusBottom
      title={t("userManagementPage.newUser_title")}
      handleShowModal={() => null}
      show={showAddUserModal}
      headerContentRight={
        <SwitchButton
          switchChecked={switchChecked}
          setSwitchChecked={setSwitchChecked}
          isSendInvitationEnabled={isSendInvitationEnabled}
        />
      }
      footerContent={
        <FooterButtons
          setShowAddUserModal={setShowAddUserModal}
          handleResetForm={handleResetForm}
          submitNewUser={submitNewUser}
          disabledButton={disabledButton}
          isLoading={isPending}
        />
      }
    >
      <AddUser
        {...rest}
        disabledButton={disabledButton}
      />
    </HyperFocusBottom>
  )
}
